import Vue from 'vue';

Vue.component('data-grid', () => import('./data-grid'))
Vue.component('data-grid-toolbar', () => import('./data-grid/toolbar'))
Vue.component('data-grid-filter', () => import('./data-grid/filter'))
Vue.component('my-dialog', () => import('./my-dialog'))
Vue.component('html-editor', () => import('./html-editor'))
Vue.component('orders-state', () => import('./orders-state'))
Vue.component('orders-pay-type', () => import('./orders-pay-type'))
Vue.component('orders-comment-level', () => import('./orders-comment-level'))


Vue.component('money-record-type', () => import('./money-record-type'))

Vue.component('score-orders-state', () => import('./score-orders-state'))
Vue.component('score-record-type', () => import('./score-record-type'))



// WEBPACK FOOTER //
// ./src/components/index.js